'use strict';

exports.__esModule = true;
exports.ChatMessageView = exports.styles = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp; // import LinkIcon from "material-ui-icons/Link";


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Editable = require('../../../../view/Object/Editable');

var _Editable2 = _interopRequireDefault(_Editable);

var _Paper = require('material-ui/Paper');

var _Paper2 = _interopRequireDefault(_Paper);

var _withStyles = require('material-ui/styles/withStyles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Send = require('material-ui-icons/Send');

var _Send2 = _interopRequireDefault(_Send);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _Typography = require('material-ui/Typography');

var _Typography2 = _interopRequireDefault(_Typography);

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      // border: "1px solid blue",
      // height: "100%",
      // display: "flex",
      // flexDirection: "column",
      padding: 10,
      "& .DraftEditor-root": {
        "& .public-DraftEditor-content": {
          "&[contenteditable=true]": {
            maxHeight: 250,
            overflow: "auto"
          }
        }
      }
    }
  };
};

var ChatMessageView = exports.ChatMessageView = (_temp = _class = function (_EditableView) {
  _inherits(ChatMessageView, _EditableView);

  function ChatMessageView() {
    _classCallCheck(this, ChatMessageView);

    return _possibleConstructorReturn(this, _EditableView.apply(this, arguments));
  }

  ChatMessageView.prototype.canEdit = function canEdit() {
    var _ref = this.getObjectWithMutations() || {},
        id = _ref.id,
        CreatedBy = _ref.CreatedBy;

    var _ref2 = CreatedBy || {},
        createdById = _ref2.id;

    var _ref3 = this.getCurrentUser() || {},
        currentUserId = _ref3.id;

    return !id || currentUserId && currentUserId === createdById ? true : false;
  };

  ChatMessageView.prototype.getTitle = function getTitle() {
    var _ref4 = this.getObjectWithMutations() || {},
        id = _ref4.id;

    return id;
  };

  ChatMessageView.prototype.renderHeader = function renderHeader() {
    return null;
  };

  ChatMessageView.prototype.renderResetButton = function renderResetButton() {
    var _getObjectWithMutatio = this.getObjectWithMutations(),
        id = _getObjectWithMutatio.id;

    return id ? _EditableView.prototype.renderResetButton.call(this) : null;
  };

  ChatMessageView.prototype.renderDefaultView = function renderDefaultView() {
    var _this2 = this;

    var _context = this.context,
        Grid = _context.Grid,
        Editor = _context.Editor,
        UserLink = _context.UserLink,
        ChatRoomLink = _context.ChatRoomLink,
        ChatMessageLink = _context.ChatMessageLink;
    var classes = this.props.classes;

    _objectDestructuringEmpty(this.state);

    var object = this.getObjectWithMutations();
    var objectId = object.id,
        content = object.content,
        createdAt = object.createdAt,
        updatedAt = object.updatedAt,
        Room = object.Room,
        CreatedBy = object.CreatedBy;
    var inEditMode = this.isInEditMode();
    return _react2.default.createElement(_Paper2.default, {
      className: classes.chat
    }, _react2.default.createElement(Grid, {
      container: true,
      spacing: 16
    }, _react2.default.createElement(Grid, {
      item: true
    }, CreatedBy ? _react2.default.createElement('div', {
      style: {
        marginTop: 20
      }
    }, _react2.default.createElement(UserLink, {
      user: CreatedBy,
      showName: false
    })) : null), _react2.default.createElement(Grid, {
      item: true,
      xs: true
    }, _react2.default.createElement(Grid, {
      container: true,
      spacing: 8
    }, _react2.default.createElement(Grid, {
      item: true,
      xs: 12
    }, _react2.default.createElement(Grid, {
      container: true,
      spacing: 8,
      alignItems: 'flex-end'
    }, _react2.default.createElement(Grid, {
      item: true
    }, CreatedBy ? _react2.default.createElement(UserLink, {
      user: CreatedBy,
      withAvatar: false
    }) : null), _react2.default.createElement(Grid, {
      item: true
    }, _react2.default.createElement(ChatMessageLink, {
      object: object
    }, _react2.default.createElement(_Typography2.default, {
      color: 'textSecondary'
    }, createdAt && (0, _moment2.default)(createdAt).format("lll") || null))), _react2.default.createElement(Grid, {
      item: true,
      xs: true
    }), _react2.default.createElement(Grid, {
      item: true
    }, Room ? _react2.default.createElement(ChatRoomLink, {
      object: Room
    }) : null))), _react2.default.createElement(Grid, {
      item: true,
      xs: 12
    }, _react2.default.createElement(Editor, {
      key: updatedAt + '-' + inEditMode,
      value: content,
      readOnly: !inEditMode,
      onChange: function onChange(content) {
        return _this2.updateObject({
          content: content
        });
      }
    })))), _react2.default.createElement(Grid, {
      item: true
    }, this.getButtons())));
  };

  ChatMessageView.prototype.renderEditableView = function renderEditableView() {
    return this.renderDefaultView();
  };

  ChatMessageView.prototype.componentDidMount = function componentDidMount() {
    /**
     * Когда сообщение загружено, 
     * надо его отметить прочитанным
     */
    var _context2 = this.context,
        currentUser = _context2.user,
        markAsReadedChatMessage = _context2.query.markAsReadedChatMessage,
        client = _context2.client;

    var _ref5 = currentUser || {},
        currentUserId = _ref5.id;

    if (currentUserId) {
      var object = this.props.data.object;

      var _ref6 = object || {},
          id = _ref6.id,
          ReadedBy = _ref6.ReadedBy;

      if (id && ReadedBy && ReadedBy.findIndex(function (n) {
        return n.User.id === currentUserId;
      }) === -1) {
        client.mutate({
          mutation: (0, _graphqlTag2.default)(markAsReadedChatMessage),
          variables: {
            where: {
              id: id
            }
          }
        });
      }
    }

    _EditableView.prototype.componentDidMount && _EditableView.prototype.componentDidMount.call(this);
  };

  ChatMessageView.prototype.render = function render() {
    var classes = this.props.classes;
    return _react2.default.createElement('div', {
      className: classes.root
    }, _EditableView.prototype.render.call(this));
  };

  return ChatMessageView;
}(_Editable2.default), _class.defaultProps = _extends({}, _Editable2.default.defaultProps, {
  SaveIcon: _Send2.default
}), _temp);
exports.default = (0, _withStyles2.default)(styles)(function (props) {
  return _react2.default.createElement(ChatMessageView, props);
});